module.exports = {
  STOPPED: 'stopped',
  DISTURBED: 'disturbed',
};
